<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Selected Products</h1>
<div mat-dialog-content>
    <!-- <form [formGroup]="partialUpdateDeliveryForm" *ngIf="partialUpdateDeliveryForm" (ngSubmit)="onSubmit()"> -->
    <form>
        <div class="delivery-colle-data-box">
            <fieldset>
                <legend>PRODUCTS:</legend>

                <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">#ID</th>
                        <th scope="col">PRODUCT NAME</th>
                        <th scope="col">PARTNER</th>
                        <th scope="col">SKU</th>
                        <th scope="col">STATUS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let product of products">
                        <th scope="row">#{{ product.id || "---" }}</th>
                        <td>{{ product.name || "---" }}</td>
                        <td>{{ (product.partner?.businessName) ? product.partner?.businessName : '' }}</td>
                        <td>{{ product.sku || "---" }}</td>
                        <td>
                            <select (change)="changeProductStatus(product.id, $event.target.value)">
                                <option *ngFor="let status of productStatus" [value]="status.value" [selected]="status.value == product.productStatus">
                                  {{status.ln.it}}
                                </option>
                            </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>

            </fieldset>
        </div>
    </form>
</div>

<div mat-dialog-actions>
    <div class="btn-submit">
        <button mat-button class="btn" [disabled]="disableBtn" (click)="saveUpdatedInfo()">Salva<i class="ml-10 far fa-save"></i></button>
    </div>
</div>